document.addEventListener('DOMContentLoaded', function () {
  var widget = document.querySelector('[data-floating-help]');
  if (!widget) return;
  var toggle = widget.querySelector('[data-floating-help-toggle]');
  var closeBtn = widget.querySelector('[data-floating-help-close]');
  var panel = widget.querySelector('[data-floating-help-panel]');

  function openPanel() {
    panel.hidden = false;
    widget.classList.add('is-open');
    toggle.setAttribute('aria-label', "Fermer l'aide");
  }

  function closePanel() {
    panel.hidden = true;
    widget.classList.remove('is-open');
    toggle.setAttribute('aria-label', "Ouvrir l'aide");
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) {
      openPanel();
    } else {
      closePanel();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  document.addEventListener('click', function (event) {
    if (!widget.contains(event.target) && !panel.hidden) {
      closePanel();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) {
      closePanel();
    }
  });
});
